<template>
  <nav class="px-nav px-nav-left px-nav-fixed px-nav-animate" v-bind:class="{'px-nav-expand px-nav-collapse': show===true}">
    
    <button @click="show=!show" type="button" class="px-nav-toggle" data-toggle="px-nav" style="background-color: #17a2b8!important;">
      <span class="px-nav-toggle-arrow"></span>
      <span class="navbar-toggle-icon"></span>
      <span class="px-nav-toggle-label font-size-11">{{ $t('hide') }}</span>
    </button>

    <div class="px-nav-scrollable-area" @click="auto_hide()"><ul class="px-nav-content"><li class="px-nav-item">      </li>
        <li class="px-nav-box p-3 b-b-1" style="padding-bottom:10px!important;     text-align: center;">
            <router-link tag="a" to="/user"><b-img :src="$auth.user().profile.avatar" alt="" id="avatar_small" rounded="circle"  class="pull-left mr-2" style="width: 60px; height: 60px;"/></router-link>
            <div class="font-size-16"><span class="font-weight-light">{{ $t('hello') }}, </span><strong>{{$auth.user().profile.name}}</strong></div>
            <div class="btn-group" style="margin-top: 5px; ">
              <router-link tag="a" to="/user/settings" class="btn btn-md btn-primary btn-outline" v-b-tooltip.hover :title="$t('profile_settings')"><i class="fa fa-user"></i></router-link>
              <router-link tag="a" to="/user/security" class="btn btn-md btn-primary btn-outline" v-b-tooltip.hover :title="$t('access_settings')"><i class="fa fa-cog"></i></router-link>
            </div>
        </li>
          <router-link class="px-nav-item" tag="li" v-for="routes in links" 
                       v-bind:key="routes.id" 
                       :to="`${routes.page}`" v-if="routes.hide_on_empty!==true || (routes.count && $auth.user().noty[routes.count]>0) || (routes.count2 && $auth.user().noty[routes.count2]>0) || (routes.count3 && $auth.user().noty[routes.count3]>0)">
                <a><span><i :class="routes.class"></i><span class="px-nav-label">{{routes.text}}
                  <b-badge variant="success" v-if="routes.count" class="message_count">{{$auth.user().noty[routes.count]}}</b-badge>
                  <b-badge variant="warning" v-if="routes.count2" class="message_count">{{$auth.user().noty[routes.count2]}}</b-badge>  
                  <b-badge variant="primary" v-if="routes.count3" class="message_count">new</b-badge>  
                </span></span></a>

          </router-link>
            <router-link v-if="$auth.user().isAdmin" class="px-nav-item" tag="li"
                          to="/admin"><a><span><i class="px-nav-icon fa fa-cogs"></i><span class="px-nav-label">Панель управления</span></span></a></router-link>
      </ul></div>
    
  </nav>
</template>
<i18n>
{
  "en": {
    "hide": "Hide menu",
    "hello": "Hello",
    "profile_settings": "Profile settings",
    "access_settings": "Access settings",
    "my_page": "My page",
    "news": "News",
    "notifications": "Notifications",
    "events": "Events",
    "publications": "Publications",
    "applications": "Applications",
    "chat": "Chat",
    "friends": "Experts",
    "review": "Review",
    "bills": "Documents",
    "directions": "Assessment"
    
  },
  "ru": {
    "hide": "Спрятать меню",
    "hello": "Здравствуйте",
    "profile_settings": "Настройки профиля",
    "access_settings": "Настройки доступа",
    "my_page": "Моя страница",
    "news": "Новости",
    "notifications": "Уведомления",
    "events": "Мероприятия",
    "publications":"Публикации",
    "applications": "Заявки",
    "chat": "Сообщения",
    "friends": "Эксперты",
    "review": "Рецензирование",
    "bills": "Библиотека проектов",
    "directions": "Экспертиза"
  }
}
</i18n>
<script>

    export default {
      name: 'navpanel',
      data () {
        return {
          counts: {},
          test:'user_new_news',
          show:false,
          role: null,
          links: [
            {
              id: 0,
              text: this.$t('my_page'),
              page: '/user',
              icon: '/123.png',
              class: 'px-nav-icon fa fa-user',
              count2: 'count_tasks'
            },
            {
              id: 1,
              text: this.$t('news'),
              page: '/news',
              class: 'px-nav-icon fa fa-list-alt',
              count: 'user_new_news'
            },
            {
              id: 2,
              text: this.$t('notifications'),
              page: '/notifications',
              class: 'px-nav-icon fa fa-flag',
              count: 'user_new_notifications'
            },
            {
              id: 3,
              text: this.$t('directions'),
              page: '/activities',
              class: 'px-nav-icon fa fa-compass'
            },
            {
              id: 4,
              text: this.$t('bills'),
              page: '/documents',
              class: 'px-nav-icon fa fa-newspaper-o'
            },
            {
              id: 5,
              text: this.$t('chat'),
              page: '/chat',
              class: 'px-nav-icon fa fa-comments-o',
              count: 'count_new_messages'
            },
            {
              id: 6,
              text: this.$t('friends'),
              page: '/friends',
              class: 'px-nav-icon fa fa-users',
              count: 'count_new_friends'
            },
            {
              id: 7,
              text: this.$t('review'),
              page: '/review',
              class: 'px-nav-icon fa fa-pencil',
              count: 'count_to_review',
              count2: 'count_review_answers',
              count3: 'new_review_invitations',
              hide_on_empty: true
             },
            // {
            //  id: 9,
            //  text: 'Панель администратора',
            //  page: '/admin',
            //  class: 'px-nav-icon fa fa-flag'
            // }
          ],
          user_photo: '',
          user_second_name: ''
        }
      },
      created () {
      },
      methods: {
          auto_hide () {
              if(window.innerWidth<545)
              {
                this.show=false;
              }              
          }
      },
      watch: {
        // эта функция запускается что бы обновить язык в links
        '$i18n.locale': function () {
          Object.assign(this.$data,this.$options.data.call(this))
        },
      },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    #avatar_small{
            width: 60px; height: 60px;
    }

    .btn-group{
            margin-top: 5px;
    }

    .px-nav-item.router-link-active>a {
    color: #fff!important;
    background: #4490e9;
}

.px-nav-scrollable-area {
    height: auto !important; 
    padding-top: 45px;
}
.px-nav-toggle {

      border-right: 0px !important;
      box-shadow: none !important;
}
.b-b-1 {
  border-bottom-width: 1px !important;
  border-bottom-style: solid !important; }
</style>
